import Axios from '@/packages/axios/Axios';
import store from '@/packages/vuex/store';
import Vue from 'vue';

export default (vue) => {
  const lVue = vue;
  lVue.auth = {
    destroyToken() {
      localStorage.removeItem('access_token');
      localStorage.removeItem('expiration');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('token_type');
    },
    get_token() {
      const accessToken = localStorage.getItem('access_token');
      const expiration = localStorage.getItem('expiration');
      if (!accessToken || !expiration) return null;

      if (parseInt(Date.now() / 1000, 10) > parseInt(expiration, 10)) {
        /*----------------------------------------------------------------------
         * TODO Refresh Token before detroying it
         *----------------------------------------------------------------------
         * We can utilise the oauth/token/refresh with the refresh_token to
         * obtain a new user token...
         */

        this.destroyToken();
        return null;
      }
      return accessToken;
    },
    isAuthenticated() {
      if (this.get_token()) {
        return true;
      }
      return false;
    },
    refresh_token() {
      Axios.post('/oauth/token', {
        grant_type: 'refresh_token',
        refresh_token: localStorage.getItem('refresh_token'),
        scope: '',
      })
        .then((response) => {
          this.set_token(response.data);
          store.commit('RESET_TOKEN_EXPIRATION_COUNTDOWN');
        })
        .catch(() => {});
    },
    set_token(token) {
      localStorage.setItem('access_token', token.access_token);
      localStorage.setItem('expiration', token.expires_in + Date.now() / 1000);
      localStorage.setItem('refresh_token', token.refresh_token);
      localStorage.setItem('token_type', token.token_type);

      Axios.defaults.headers.common.Authorization = `${token.token_type} ${token.access_token}`;
    },
  };
  Object.defineProperties(Vue.prototype, {
    $auth: {
      get() {
        return lVue.auth;
      },
    },
  });
};
